<div class="perf-chart-header">
  <div>
    <p class="ds-heading-1">{{ 'PERFORMANCE.performanceChart.heading' | translate }}</p>
    <ion-icon (click)="onToggleInfo('title')" name="info2"></ion-icon>
  </div>

  <ng-container *ngIf="infoList['title']">
    <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'PERFORMANCE.performanceChart.info' | translate"></p>
  </ng-container>
</div>

<div class="perf-type">
  <app-ds-content-switcher
    [type]="'medium'"
    [tabs]="tabs"
    [activeTab]="performance?.chartType"
    (tabSwitched)="onTypeChange($event)"
  ></app-ds-content-switcher>
</div>
<div class="perf-tabs" [class.perf-tabs-3b]="hasPortfolioUpdatesFlag || (kind !== '3a' && !hasPortfolioUpdatesFlag)">
  <app-ds-tab-nav [tabs]="performanceFilters" [activeTab]="performance?.range" (tabSwitched)="onFilterChange($event)"></app-ds-tab-nav>
  @if (hasPortfolioUpdatesFlag || (kind !== '3a' && !hasPortfolioUpdatesFlag)) {
    <div class="perf-adjustmets" (click)="onOpenPerfSettings(performance?.showBenchmark ?? false)">
      <app-ds-icon name="sliders-horizontal" color="var(--color-core-neutral-6)"></app-ds-icon>
    </div>
  }
</div>
<div class="perf-chart">
  @if (performance?.loading) {
    <div *ngIf="performance?.loading" class="perf-spinner">
      <!--   <ion-spinner name="lines"></ion-spinner>-->
      <ion-icon name="inyova" class="loading-icon"></ion-icon>
    </div>
  } @else {
    @if (chartData.length === 0) {
      <div class="perf-nodata">
        <p class="perf-empty">{{ 'INSIGHTS.performance.empty' | translate }}</p>
      </div>
    }
  }
  <!-- Tooltip -->
  @if (showTooltip) {
    <div class="perf-tooltip">
      <div class="perf-values" [class.is-perf-chart]="isPerformanceChart">
        @if (isPerformanceChart) {
          <div class="perf-data">
            <p class="ds-color-core-neutral-6 ds-caption-3">{{ 'PERFORMANCE.performanceChart.tooltip.portfolio' | translate }}</p>
            <app-ds-returns
              size="small"
              type="custom"
              customColor="var(--color-core-neutral-9)"
              [value]="tooltipData.performance[0].percentage"
            ></app-ds-returns>
          </div>
          <div class="perf-data">
            @if (performance?.showBenchmark && is3bProduct) {
              <p class="ds-color-core-neutral-6 ds-caption-3">{{ 'PERFORMANCE.performanceChart.tooltip.benchmark' | translate }}</p>
              <app-ds-returns
                size="small"
                type="custom"
                customColor="var(--color-core-neutral-9)"
                [value]="tooltipData.performance[1].percentage"
              ></app-ds-returns>
            }
          </div>
          <div class="perf-data">
            @if (performance?.showBenchmark && is3bProduct) {
              <p class="ds-color-core-neutral-6 ds-caption-3">{{ 'PERFORMANCE.performanceChart.tooltip.vsBenchmark' | translate }}</p>
              <app-ds-returns
                size="small"
                type="custom"
                customColor="var(--color-core-neutral-9)"
                [value]="tooltipData.performance[2].percentage"
              ></app-ds-returns>
            }
          </div>
        } @else {
          <div class="perf-data">
            <p class="ds-color-core-neutral-6 ds-caption-3">{{ 'PERFORMANCE.performanceChart.tooltip.totalValue' | translate }}</p>
            <p class="ds-caption-3 ds-color-core-neutral-9">{{ tooltipData.balance.amount.toFixed(0) | thousand: currency : false }}</p>
          </div>
          <div class="perf-data">
            <p class="ds-color-core-neutral-6 ds-caption-3">{{ 'PERFORMANCE.performanceChart.tooltip.moneyInOut' | translate }}</p>
            <p class="ds-caption-3 ds-color-core-neutral-9">{{ tooltipData.balance.moneyInOut.toFixed(0) | thousand: currency : false }}</p>
          </div>
          <div class="perf-data">
            <p class="ds-color-core-neutral-6 ds-caption-3">{{ 'PERFORMANCE.performanceChart.tooltip.periodReturn' | translate }}</p>
            <p class="ds-caption-3 ds-color-core-neutral-9">{{ tooltipData.balance.moneyReturn.toFixed(0) | thousand: currency : true }}</p>
          </div>
        }
      </div>

      <div class="perf-date" [class.is-perf-chart]="isPerformanceChart">
        <div class="ds-caption-3 ds-color-core-neutral-5">{{ tooltipData.date | dateTranslate: 'short' : language }}</div>
        @if (
          hasPortfolioUpdatesFlag &&
          isPerformanceChart &&
          (tooltipData.stockSplit.stockPercent !== null || tooltipData.stockSplit.fundPercent !== null)
        ) {
          <div class="perf-split">
            <span
              class="ds-caption-3"
              [style.color]="tooltipData.stockSplit.fundPercent !== 0 ? 'var(--color-core-brand-4-7)' : 'var(--color-core-brand-6-7)'"
            >
              {{ tooltipData.stockSplit.fundPercent !== 0 ? tooltipData.stockSplit.fundPercent : tooltipData.stockSplit.stockPercent }}%
            </span>
            <span class="ds-caption-3 ds-color-core-neutral-5">/</span>
            <span class="ds-caption-3" style="color: var(--color-core-brand-5-7)">{{ tooltipData.stockSplit.bondPercent }}%</span>
            <span class="ds-caption-3 ds-color-core-neutral-5">/</span>
            <span class="ds-caption-3 ds-color-core-neutral-8">{{ tooltipData.stockSplit.cashPercent }}%</span>
          </div>
        }
      </div>
    </div>
  }
  <!-- End tooltip-->
  <div class="perf-wrap">
    @if (showPortfolioUpdateTooltip) {
      <div
        class="perf-update-tooltip"
        [style.left.px]="portfolioUpdateTooltip.position.left"
        [style.top.px]="portfolioUpdateTooltip.position.top"
        [style.height.px]="portfolioUpdateTooltip.tooltipHeight"
      >
        <div class="perf-update-content">
          <h3 class="ds-caption-2">{{ 'INVEST.performance.changeCard.ChangeCardTitle' | translate }}</h3>

          @if (portfolioUpdateTooltip.data.previous.stock_percentage !== 0 || portfolioUpdateTooltip.data.current.stock_percentage !== 0) {
            <div class="perf-update-split">
              <span class="ds-caption-3" [style.color]="'var(--color-core-brand-6-7)'">
                {{ 'INVEST.performance.changeCard.AllocationRowLabel1' | translate }}
              </span>
              <div>
                <p class="ds-caption-3 ds-color-core-neutral-5">{{ portfolioUpdateTooltip.data.previous.stock_percentage }}%</p>
                <app-ds-icon name="arrow-right" size="icon-size-0" color="var(--color-core-neutral-5)"></app-ds-icon>
                <p class="ds-caption-3">{{ portfolioUpdateTooltip.data.current.stock_percentage }}%</p>
              </div>
            </div>
          }

          @if (portfolioUpdateTooltip.data.previous.fund_percentage !== 0 || portfolioUpdateTooltip.data.current.fund_percentage !== 0) {
            <div class="perf-update-split">
              <span class="ds-caption-3" [style.color]="'var(--color-core-brand-4-7)'">
                {{ 'INVEST.performance.changeCard.AllocationRowLabel2' | translate }}
              </span>
              <div>
                <p class="ds-caption-3 ds-color-core-neutral-5">{{ portfolioUpdateTooltip.data.previous.fund_percentage }}%</p>
                <app-ds-icon name="arrow-right" size="icon-size-0" color="var(--color-core-neutral-5)"></app-ds-icon>
                <p class="ds-caption-3">{{ portfolioUpdateTooltip.data.current.fund_percentage }}%</p>
              </div>
            </div>
          }

          <div class="perf-update-split">
            <span class="ds-caption-3" style="color: var(--color-core-brand-5-7)">
              {{ 'INVEST.performance.changeCard.AllocationRowLabel3' | translate }}
            </span>
            <div>
              <p class="ds-caption-3 ds-color-core-neutral-5">{{ portfolioUpdateTooltip.data.previous.bond_percentage }}%</p>
              <app-ds-icon name="arrow-right" size="icon-size-0" color="var(--color-core-neutral-5)"></app-ds-icon>
              <p class="ds-caption-3">{{ portfolioUpdateTooltip.data.current.bond_percentage }}%</p>
            </div>
          </div>

          <div class="perf-update-split">
            <span class="ds-caption-3 ds-color-core-neutral-8">{{ 'INVEST.performance.changeCard.AllocationRowLabel4' | translate }}</span>
            <div>
              <p class="ds-caption-3 ds-color-core-neutral-5">{{ portfolioUpdateTooltip.data.previous.cash_percentage }}%</p>
              <app-ds-icon name="arrow-right" size="icon-size-0" color="var(--color-core-neutral-5)"></app-ds-icon>
              <p class="ds-caption-3">{{ portfolioUpdateTooltip.data.current.cash_percentage }}%</p>
            </div>
          </div>
        </div>
      </div>
    }
    <svg class="performance-chart"></svg>
  </div>
</div>

<div class="perf-details">
  <div class="perf-legends">
    <app-ds-legend type="fill" color="custom" [customColor]="isPerformanceChart ? 'var(--color-core-brand-6-5)' : 'var(--color-core-brand-5-5)'">
      <span class="ds-ui-3 ds-color-core-neutral-7">
        {{ (isPerformanceChart ? 'PERFORMANCE.performanceChart.portfolioLabel' : 'PERFORMANCE.performanceChart.totalValueLabel') | translate }}
      </span>
    </app-ds-legend>

    @if (is3bProduct) {
      @if (isPerformanceChart) {
        @if (performance?.showBenchmark) {
          <app-ds-legend type="fill" color="custom">
            <span class="ds-ui-3 ds-color-core-neutral-7">
              {{ 'PERFORMANCE.performanceChart.benchmarkLabel' | translate }}
            </span>
          </app-ds-legend>
        }
      }
    }

    @if (!isPerformanceChart) {
      <app-ds-legend type="fill" color="custom">
        <span class="ds-ui-3 ds-color-core-neutral-7">{{ 'PERFORMANCE.performanceChart.moneyInOutLabel' | translate }}</span>
      </app-ds-legend>
    }

    @if (performance?.showPortfolioChanges) {
      <app-ds-legend type="outline" color="custom">
        <span class="ds-ui-3 ds-color-core-neutral-7">
          {{ 'PERFORMANCE.performanceChart.eventsLabel' | translate }}
        </span>
      </app-ds-legend>
    }
  </div>
</div>
